<div *ngIf="commitmentForm" [formGroup]="commitmentForm">
  <div class="row">
    <div class="col-12">
      <p>
        <strong> Structure référente</strong>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="mb-3 text-secondary col-12 col-lg-4">
      <label>Nom de la structure</label>
      <input type="text" class="form-control" formControlName="structureLabel" />
    </div>
    <div class="mb-3 text-secondary col-12 col-lg-4">
      <label>Adresse de la structure</label>
      <input type="text" class="form-control" formControlName="structureAddress" />
    </div>
    <div class="mb-3 text-secondary col-12 col-lg-4">
      <label>Complément d'adresse</label>
      <input type="text" class="form-control" formControlName="structureAdditionalAddress" />
    </div>
  </div>
  <div class="row">
    <div class="mb-3 text-secondary col-12 col-lg-4">
      <label>Ville</label>
      <input type="text" class="form-control" formControlName="structureCity" />
    </div>
    <div class="mb-3 text-secondary col-12 col-lg-4">
      <label>Code postal</label>
      <input type="text" class="form-control" formControlName="structurePostalCode" />
    </div>
    <div class="mb-3 text-secondary col-12 col-lg-4">
      <label>Téléphone</label>
      <input type="text" class="form-control" formControlName="structurePhone" />
    </div>
  </div>
  <div class="row mb-3">
    <div class="mb-3 text-secondary col-12 col-lg-4">
      <label>Référent</label>
      <input type="text" class="form-control" formControlName="referentName" />
    </div>
    <div class="mb-3 text-secondary col-12 col-lg-4">
      <label>Téléphone du référent</label>
      <input type="text" class="form-control" formControlName="referentPhone" />
    </div>
  </div>

  <div class="row">
    <div class="mb-3 text-secondary col-12">
      <label class="fw-bold text-dark">Expliciter la situation du demandeur</label>
      <div formGroupName="situationComment">
        <div class="mb-3">
          <label for="youngPeopleProject" class="required">Projet du jeune</label>
          <textarea
            id="youngPeopleProject"
            class="form-control"
            formControlName="youngPeopleProject"
            [class.is-invalid]="submitted && commitmentForm.controls.situationComment.controls.youngPeopleProject.invalid"
          ></textarea>
          <small *ngIf="submitted && commitmentForm.controls.situationComment.controls.youngPeopleProject.invalid" class="form-text text-danger">
            Le projet du jeune est obligatoire
          </small>
        </div>
        <div class="mb-3">
          <label for="youngPeopleSteps" class="required">Démarches du jeune</label>
          <textarea
            id="youngPeopleSteps"
            class="form-control"
            formControlName="youngPeopleSteps"
            [class.is-invalid]="submitted && commitmentForm.controls.situationComment.controls.youngPeopleSteps.invalid"
          ></textarea>
          <small *ngIf="submitted && commitmentForm.controls.situationComment.controls.youngPeopleSteps.invalid" class="form-text text-danger">
            Les démarches du jeune sont obligatoires
          </small>
        </div>
        <div class="mb-3">
          <label for="proceduresProposedAdvisor" class="required">Démarches proposées par le conseiller</label>
          <textarea
            id="proceduresProposedAdvisor"
            class="form-control"
            formControlName="proceduresProposedAdvisor"
            [class.is-invalid]="submitted && commitmentForm.controls.situationComment.controls.proceduresProposedAdvisor.invalid"
          ></textarea>
          <small
            *ngIf="submitted && commitmentForm.controls.situationComment.controls.proceduresProposedAdvisor.invalid"
            class="form-text text-danger"
          >
            Les démarches proposées par le conseiller sont obligatoires
          </small>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="mb-3 text-secondary col-12">
      <label class="fw-bold text-dark">Bilan de la période précédente</label>
      <div formGroupName="assessment">
        <div class="mb-3">
          <label for="youngPeopleProjectAssessment" class="required">Projet du jeune</label>
          <textarea
            id="youngPeopleProjectAssessment"
            class="form-control"
            formControlName="youngPeopleProject"
            [class.is-invalid]="submitted && commitmentForm.controls.assessment.controls.youngPeopleProject.invalid"
          ></textarea>
          <small *ngIf="submitted && commitmentForm.controls.assessment.controls.youngPeopleProject.invalid" class="form-text text-danger">
            Le projet du jeune est obligatoire
          </small>
        </div>
        <div class="mb-3">
          <label for="youngPeopleStepsAssessment" class="required">Démarches du jeune</label>
          <textarea
            id="youngPeopleStepsAssessment"
            class="form-control"
            formControlName="youngPeopleSteps"
            [class.is-invalid]="submitted && commitmentForm.controls.assessment.controls.youngPeopleSteps.invalid"
          ></textarea>
          <small *ngIf="submitted && commitmentForm.controls.assessment.controls.youngPeopleSteps.invalid" class="form-text text-danger">
            Les démarches du jeune sont obligatoires
          </small>
        </div>
        <div class="mb-3">
          <label for="proceduresProposedAdvisorAssessment" class="required">Démarches proposées par le conseiller</label>
          <textarea
            id="proceduresProposedAdvisorAssessment"
            class="form-control"
            formControlName="proceduresProposedAdvisor"
            [class.is-invalid]="submitted && commitmentForm.controls.assessment.controls.proceduresProposedAdvisor.invalid"
          ></textarea>
          <small *ngIf="submitted && commitmentForm.controls.assessment.controls.proceduresProposedAdvisor.invalid" class="form-text text-danger">
            Les démarches proposées par le conseiller sont obligatoires
          </small>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="mb-3 text-secondary col-12">
      <label class="required fw-bold text-dark">Engagement pour les 3 prochains mois</label>
      <textarea
        class="form-control"
        formControlName="commitmentForNext3Months"
        [class.is-invalid]="submitted && commitmentForm.controls.commitmentForNext3Months.invalid"
      ></textarea>
      <small *ngIf="submitted && commitmentForm.controls.commitmentForNext3Months.invalid" class="form-text text-danger">
        L'engagement pour les 3 prochains mois est obligatoire
      </small>
    </div>
  </div>
</div>
